import {
  GetOrderRequest,
  JobBase,
  JobStatus,
  OrderFront,
  Work,
} from "@project/shared-types";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router";
import CardEditSvg from "../../../assets/taiga-uikit/icons/card-edit.svg?react";
import { BreadCrumbs } from "../../../components/BreadCrumbs/BreadCrumbs";
import { Button } from "../../../components/button/button";
import { _flexDirection, _gap, Container } from "../../../components/Container/Container";
import Dropdown from "../../../components/Dropdown/Dropdown";
import { Loader } from "../../../components/Loader/Loader";
import { TabSelection } from "../../../components/TabSelection/TabSelection";
import { Text } from "../../../components/texts/text";
import Title from "../../../components/texts/title";
import { _size, _sizeHeading, _sizeText, _style } from "../../../core/core";
import { JobAddAPI, OrderPayJobsAPI } from "../../../entities/job/model/job.api";
import { getViewer } from "../../../entities/job/ui/JobViewer/get_viewer";
import { GetOrderAPI } from "../../../entities/order/model/order.api";
import { extractOrderId } from "../../../entities/order/model/order.utils";
import { OrderCardPreview } from "../../../entities/order/ui/OrderCardPreview/OrderCardPreview";
import { useData } from "../../../entities/service/model/DataContext";
import '../../order-list/ui/OrdersList.css';
import "./OrderDetails.css";

export const OrderDetails = ({ ...props }) => {
  const { order_id } = useParams();
  const [order, setOrder] = useState<OrderFront | undefined>();
  const [jobs, setJobs] = useState<JobBase[]>([]);
  const [works, setWorks] = useState<Record<string, Work>>({});
  const [isEditJobs, setIsEditJobs] = useState(false);
  const [selected, setSelected] = useState("all");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const isActiveEditJobs = () => {
    return jobs.filter((job) => [JobStatus.DO, JobStatus.NO_WORK].includes(job.status)).length > 0;
  };

  const { products } = useData();
  useEffect(() => {
    // Функция для получения карточек услуг с сервера
    const fetchOrders = async () => {
      try {
        setIsLoading(true);
        if (order_id && !isNaN(Number(order_id))) {
          document.location.href = "/account/";
          return;
        }
        const dataRequest = {
          id: order_id,
        } as GetOrderRequest;
        const response = await GetOrderAPI(dataRequest);
        if (response.order) {
          setOrder(response.order);
          console.log(response.jobs);
          setJobs(response.jobs);
          const worksMap: Record<string, Work> = {};
          response.works.forEach((work: Work) => {
            worksMap[work.id] = work;
          });
          setWorks(worksMap);
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Ошибка при получении карточек услуг:", error);
      }
    };
    fetchOrders();
  }, []);
  const addJob = async () => {
    if (!order_id) return;
    const response = await JobAddAPI({ order_id: order_id });
    setJobs([...jobs, response.job.job as JobBase]);
  };
  const selected_list = [
    { id: "all", label: "Все задания" },
    { id: "do", label: "Запланированы" },
    { id: "work", label: "В работе" },
    { id: "close", label: "Выполнены" },
  ];
  const getFilteredJobs = () => {
    const statusMap = {
      do: [JobStatus.DO],
      work: [
        JobStatus.WORK,
        JobStatus.WAIT_CHECK,
        JobStatus.WAIT_PAY,
        JobStatus.WAIT_CHECK2,
      ],
      close: [JobStatus.CLOSE, JobStatus.NO_WORK],
      all: [
        JobStatus.DO,
        JobStatus.WORK,
        JobStatus.CLOSE,
        JobStatus.NO_WORK,
        JobStatus.WAIT_CHECK,
        JobStatus.WAIT_PAY,
        JobStatus.WAIT_CHECK2,
      ],
    };

    return jobs.filter((job) =>
      statusMap[selected as keyof typeof statusMap].includes(job.status)
    );
  };
  const handlePayJobs = async () => {
    if (!order) return;
    const response = await OrderPayJobsAPI({
      order_id: order.id,
      jobs_ids: jobs.map((job) => job.id),
    });
    if (!response) return;
    const orderId = response.order_id ?? extractOrderId(response.url);
    window.open(response.url, "_blank", "noopener");
    if (orderId) {
      document.location.href = `/account/order/${orderId}/`;
    } else {
      document.location.href = response.url;
    }
  };
  const JobViewers = useMemo(() => {
    const filteredJobs = getFilteredJobs();
    console.log(filteredJobs.length);
    return filteredJobs.map((job) => ({
      viewer: getViewer(job.type),
      job_data: job,
    }));
  }, [jobs, selected]);
  const currentPage = useLocation();
  const breadLinks = [
    { url: "/", name: "Главная" },
    { url: "/account/", name: "Профиль" },
    {
      url: currentPage.pathname,
      name: `Заказ №${order ? order.number : "..."}`,
    },
  ];
  const getWork = (job: JobBase) => {
    if (job.current_work_id) {
      return works[job.current_work_id];
    }
    return undefined;
  };
  return (
    <div className={"main-account "}>
      <div className="bread">
        <BreadCrumbs links={breadLinks}></BreadCrumbs>
      </div>
      <div className="main-account-block">
        <div className="main-account-body order-view">
          <div className="main-account-filtres">
            <Title type={_sizeHeading.h3}>
              Заказ №{order ? order.number : ""}
            </Title>
            <div className="main-account-filtres-body">
              {selected_list.map((item, index) => (
                <TabSelection
                  key={index}
                  onClick={() => setSelected(item.id)}
                  isActive={selected === item.id}
                >
                  {item.label}
                </TabSelection>
              ))}
            </div>
          </div>
          <div className="main-account-list">
            {isLoading ? (
              <Loader isLoading></Loader>
            ) : (
              <>
                {order && (
                  <OrderCardPreview
                    is_no_pay_jobs={
                      jobs.filter((job) => job.status == JobStatus.NO_WORK)
                        .length > 0
                    }
                    services={products}
                    order={order}
                    onAddJob={addJob}
                    onPayJobs={handlePayJobs}
                    is_order
                  ></OrderCardPreview>
                )}
                {jobs.length == 0 ? (
                  <div className="order-card-uslugi">
                    <Text size={_sizeText.m}>
                      {error ? error : "Задания отсутствуют"}
                    </Text>
                  </div>
                ) : (
                  <div className="o-cards">
                    <div className="o-cards-h">
                      <Title type={_sizeHeading.h3}>Задания</Title>
                      <div className="o-cards-h-g">
                        {isActiveEditJobs() && (
                          <Button
                            size={_size.S}
                            style={_style.outline}
                            icon_left={<CardEditSvg />}
                            onClick={() => setIsEditJobs((prev) => !prev)}
                          ></Button>
                        )}
                      </div>
                    </div>
                    <Dropdown
                      mobile
                      onSelect={(id: string) => setSelected(id)}
                      options={selected_list}
                    >
                      <Text size={_sizeText.m}>
                        {selected_list.find((i) => i.id === selected)?.label ||
                          selected_list[0].label}
                      </Text>
                    </Dropdown>
                    {JobViewers.map((jobViewer, index) => (
                      <>
                        <jobViewer.viewer
                          key={index}
                          is_edit={isEditJobs}
                          job_data={jobViewer.job_data}
                          work={getWork(jobViewer.job_data)}
                        />
                      </>
                    ))}
                    <Container direction={_flexDirection.column} width={"100%"} gap={_gap.s}>
                      <Button
                        width={"100%"}
                        size={_size.M}
                        onClick={addJob}
                        style={_style.outline}
                      >
                        Добавить задание
                      </Button>
                      <Button
                        width={"100%"}
                        size={_size.M}
                        onClick={handlePayJobs}
                        style={_style.primary}
                      >
                        Оплатить все
                      </Button>
                    </Container>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
